/* Copyright (c) 2021 Paul Nebel */

import PropTypes from 'prop-types';
import React from 'react';
import 'custom-piano-keys';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { parseChord, formatPianoKeys } from '../core/utils/chord-parser';

class PianoKeys extends React.PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            metronomeState,
            selectedChordSymbol,
        } = nextProps;

        const newState = {
            ...prevState,
            metronomeState,
            selectedChordSymbol,
        };

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props) {
        super(props);
        this.divRef = React.createRef();
        this.state = {
            metronomeState: props.metronomeState,
            selectedChordSymbol: props.selectedChordSymbol,
        };
    }

    setupPianoKeys() {
        // Get a context to use for rendering
        const pianoKeys = this.divRef.current;
        pianoKeys.setMarkedKeys([]);
        try {
            const attributes = Object.keys(this.props);
            for (let i = 0; i < attributes.length; i = i + 1) {
                const attribute = attributes[i];
                pianoKeys.setAttribute(attribute, this.props[attribute]);
            }
            pianoKeys.setMarkedKeys(formatPianoKeys(this.state.selectedChordSymbol));
        } catch (e) {
            // write the error message to the canvas.
            console.log(e);
        }
    }
    
    componentDidUpdate() {
        this.setupPianoKeys();
    }
    
    // Called after render
    componentDidMount() {
        this.setupPianoKeys();
    }

    render() {
        return (
            <custom-piano-keys
                ref={this.divRef}
            />
        );
    }
}

const mapStateToProps = ({
    metronomeState,
    selectedChordSymbol,
}) => {
    return {
        metronomeState,
        selectedChordSymbol,
    };
};

PianoKeys.propTypes = {
    'oct-count': PropTypes.number,
    'oct-w-factor': PropTypes.number,
    height: PropTypes.number,
    'stroke-w': PropTypes.number,
    'b-key-w': PropTypes.number,
    'b-key-h': PropTypes.number,
    'mark-color': PropTypes.string,
    'mark-shape': PropTypes.string,
    'mark-diameter': PropTypes.number,
    'b-key-mark-shift': PropTypes.number,
    'w-key-mark-shift': PropTypes.number,
    metronomeState: PropTypes.string,
    selectedChordSymbol: PropTypes.object,
};

PianoKeys.defaultProps = {
    'oct-count': 2,
    'oct-w-factor': 1.5,
    height: 100,
    'stroke-w': 2,
    'b-key-w': 50,
    'b-key-h': 60,
    'mark-color': 'red',
    'mark-shape': 'circle',
    'mark-diameter': 40,
    'b-key-mark-shift': 50,
    'w-key-mark-shift': 50,
    metronomeState: 'inactive',
    selectedChordSymbol: parseChord('F'),
};

export default connect(
    mapStateToProps,
    null,
)(PianoKeys);